export default __webpack_public_path__ + "static/media/timetable.9c4710a2.svg";